/* RESPONSIBLE TEAM: team-ai-agent */
import AutomationFinAIAgentProcedurePreviewRoute from 'embercom/routes/apps/app/automation/fin-ai-agent/procedures/procedure/preview';

export default AutomationFinAIAgentProcedurePreviewRoute;
